<ng-container *appDeviceType="'signup';extra:{width:770}">
  <div *ngIf="isTopImg()" class="mobile-view-background-image"></div>
</ng-container>


<div class="layout">
  <div class="container">
    <div class="leftcontainer">
      <div class="header logo" *ngIf="!isMobileView">
        <a (click)="navigate('login')" style="width: auto"><div class="mr-2 header-logo"></div></a>
      </div>
      <div class="content" [ngClass]="getContentStyle()">
        <app-common-welcome
          *ngIf="isIdPEnabled && page === 'login'"
          [continueText]="'Continue'"
          (next)="handleAuth('')">
          <div class="tenant-own-site" *ngIf="tenantWebsite">
            <p>
              Go to <a class="navigate-link" [href]="tenantWebsite">{{tenantWebsite | tenantDomainName}}</a>
            </p>
          </div>
        </app-common-welcome>
        <app-forgot-password
          *ngIf="['forgotpass', 'otp', 'updatepass'].includes(page)"
          (routing)="navigate($event)"
          [userProfile]="userProfile"
          [page]="page"
          (updatePageConfig)="updatePageConfig($event)"
        ></app-forgot-password>
        <app-signin
          *ngIf="page === 'login' && !isIdPEnabled"
          [SSObutton]="SSObutton"
          (routing)="navigate($event)"
          [SSO_val]="SSO_val"
          [userProfile]="userProfile"
        ></app-signin>
        <app-email-signup
          *ngIf="page === 'signup'"
          [SSObutton]="SSObutton"
          (routing)="navigate($event)"
          [SSO_val]="SSO_val"
          [userProfile]="userProfile"
        ></app-email-signup>
        <app-ssosignup
          *ngIf="page === 'ssosignup'"
          [userProfile]="userProfile"
        ></app-ssosignup>
        <app-idp-based-signup
          [userProfile]="userProfile"
          *ngIf="page === 'single-sign-on'">
        </app-idp-based-signup>
      </div>
    </div>
    <div class="rightcontainer"></div>
  </div>
</div>
<l-footer [signupFlag]="true"></l-footer>

<ng-template #SSObutton let-ssoVal="ssoVal">
  <div class="federated-signup" (click)="handleAuth(ssoVal.name)">
    <div class="federated-icon">
      <span [ngStyle]="{ 'background-image': ssoVal.img }"></span>
    </div>
    <div class="federated-button">
      Continue with {{ ssoVal.name }}
      <ng-container *ngIf="ssoVal.name === 'Apple'">&nbsp;</ng-container>
    </div>
  </div>
</ng-template>
